import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { lenderResponseMarkAsPaidOut } from "../../api";
import type { ILenderResponseInput } from "../../types/lender-response";
import { useLenderResponseOptimisticallyUpdate } from "../use-lender-response-optimistically-update";

interface IMutationInput {
  lenderCompanyId: number;
  lenderResponseId: number;
  input: ILenderResponseInput;
}

type IMutationResult = Awaited<ReturnType<typeof lenderResponseMarkAsPaidOut>>;

export const useMarkAsPaidOut = () => {
  const optimisticallyUpdateLenderResponse =
    useLenderResponseOptimisticallyUpdate();

  return useMutation<IMutationResult, AxiosError, IMutationInput>({
    mutationFn: async ({ lenderResponseId, lenderCompanyId, input }) => {
      return await lenderResponseMarkAsPaidOut(
        lenderCompanyId,
        lenderResponseId,
        input,
      );
    },
    mutationKey: mutationKeyMap.markAsPaidOut,
    onSuccess: () => {
      optimisticallyUpdateLenderResponse();
    },
  });
};
